import React from 'react';

import IdntyDownloadView from '../presentational/IdntyDownloadView';

const IdntyRegistrationConfirmationContainer = () => (
  <IdntyDownloadView />
);

export default IdntyRegistrationConfirmationContainer;
